import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams, useNavigate } from "react-router-dom";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function EditBOMItem() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [boms, setBoms] = useState([]);
  const [materials, setMaterials] = useState([]);

  const [data, setData] = useState({
    bom_id: "",
    raw_material_id: "",
    quantity: ""
  });

  useEffect(() => {
    fetchBOMItem();
    fetchBOMs();
    fetchMaterials();
  }, []);

  // Fetch BOMItem details
  const fetchBOMItem = () => {
    axios.get(baseUrl + "bom-items/" + id + "/")
      .then(res => {
        setData({
          bom_id: res.data.bom?.id || "",
          raw_material_id: res.data.raw_material?.id || "",
          quantity: res.data.quantity
        });
      })
      .catch(() => Swal.fire("Error", "Could not fetch BOM Item", "error"));
  };

  // Fetch BOM list
  const fetchBOMs = () => {
    axios.get(baseUrl + "bom/")
      .then(res => setBoms(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch BOMs", "error"));
  };

  // Fetch Raw Materials list
  const fetchMaterials = () => {
    axios.get(baseUrl + "eqp-search/")
      .then(res => setMaterials(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch Raw Materials", "error"));
  };

  const inputHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const formSubmit = () => {
    if (!data.bom_id || !data.raw_material_id || !data.quantity) {
      Swal.fire("Error", "All fields are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("bom", data.bom_id);
    _formData.append("raw_material", data.raw_material_id);
    _formData.append("quantity", data.quantity);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.put(baseUrl + "bom-items/" + id + "/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(response => {
      if (response.status === 200) {
        Swal.fire({
          title: "BOM Item Updated",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });

        setTimeout(() => {
          window.location.href = ('/bomitem/');
        }, 2000);
      }
    })
    .catch(() => Swal.fire("Error", "Update failed", "error"));
  };

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h4>Edit BOM Item</h4>

        {/* BOM Dropdown */}
        <select
          name="bom_id"
          value={data.bom_id}
          onChange={inputHandler}
          className="form-control mt-3"
        >
          <option value="">Select BOM</option>
          {boms.map((b, index) => (
            <option key={index} value={b.id}>
              {b.product?.name} - {b.version}
            </option>
          ))}
        </select>

        {/* Raw Material Dropdown */}
        <select
          name="raw_material_id"
          value={data.raw_material_id}
          onChange={inputHandler}
          className="form-control mt-3"
        >
          <option value="">Select Raw Material</option>
          {materials.map((m, index) => (
            <option key={index} value={m.id}>
              {m.product}
            </option>
          ))}
        </select>

        {/* Quantity Input */}
        <input
          type="number"
          className="form-control mt-3"
          name="quantity"
          value={data.quantity}
          onChange={inputHandler}
          placeholder="Quantity"
        />

        {/* Buttons */}
        <button className="btn btn-primary mt-3" onClick={formSubmit}>
          Update
        </button>

      </div>
    </div>
  );
}

export default EditBOMItem;
